module.exports = __webpack_public_path__ + "src/assets/img/share/bgs/pleasant/18c2d978bb3493c85d73a8778f1965ec.png";